import { Casa, Estudo, Mes, Perfil, Pessoa, Sessao, Territorio, Visita, } from '@sheafyield/dominio';
import { normalizarIso } from './protocolo.js';
export class ErroDeMapeamento extends Error {
    name = 'ErroDeMapeamento';
}
const SCHEMAS = {
    perfil: Perfil,
    pessoa: Pessoa,
    visita: Visita,
    estudo: Estudo,
    sessao: Sessao,
    mes: Mes,
    territorio: Territorio,
    casa: Casa,
};
// Toda coluna timestamptz do esquema. O PostgREST devolve "+00"; o app só fala Z.
export const COLUNAS_DE_DATA = [
    'updated_at',
    'server_updated_at',
    'em',
    'inicio',
    'fim',
    'iniciado_em',
    'encerrado_em',
    'proxima_visita_em',
    'enviado_em',
    'recebido_em',
    'devolvido_em',
    'ultima_visita_em',
];
// As tabelas locais têm as mesmas colunas do Postgres: subir é tirar o que só
// o servidor escreve.
// Coluna que este cliente não conhece: o payload da fila já passou pelo zod,
// que descarta chaves desconhecidas, então uma coluna que o servidor tenha e
// este cliente ainda não (esquema novo, cliente velho) some do payload. O que
// a protege é o próprio PostgREST, que monta a lista de colunas do comando a
// partir da **união das chaves do corpo**: ausente de todas as linhas, a
// coluna desconhecida não entra nem no INSERT (onde pega o default da
// tabela) nem no `ON CONFLICT DO UPDATE SET` (onde fica **como estava**).
// Isso não depende de cabeçalho nenhum — o `Prefer: missing=default` que
// `transporteSupabase` manda só muda o lote heterogêneo, que este cliente
// não produz; a razão de mandá-lo assim mesmo está escrita lá.
// `postgrestEmMemoria` modela esse comportamento, e `motor.test.ts` prova o
// ida-e-volta com uma `coluna_do_futuro` intacta no fim.
// O `dono` é carimbado na saída, e não confiado ao payload, porque a RLS de
// toda tabela é `with check (auth.uid() = user_id)`: uma linha com outro
// dono volta em 403, e o motor trata 403 como transitória — a fila da tabela
// inteira repetiria com backoff para sempre, carregando junto as linhas boas
// escritas depois do login, sem nada aparecer em Ajustes. O app escreve
// linhas antes de existir conta (a spec exige que ele funcione sem uma), e é
// aqui, no último ponto antes do fio, que o dono verdadeiro entra. De quebra
// isto conserta as linhas que já estavam na fila.
export function paraRemoto(tabela, payload, dono) {
    void tabela;
    const { server_updated_at, ...resto } = payload;
    void server_updated_at;
    return { ...resto, user_id: dono };
}
export function deRemoto(tabela, row) {
    const normalizada = { ...row };
    for (const c of COLUNAS_DE_DATA) {
        if (c in normalizada &&
            normalizada[c] !== null &&
            normalizada[c] !== undefined) {
            const iso = normalizarIso(normalizada[c]);
            normalizada[c] = iso === '' ? null : iso;
        }
    }
    if ('tags' in normalizada && !Array.isArray(normalizada['tags']))
        normalizada['tags'] = [];
    const resultado = SCHEMAS[tabela].safeParse(normalizada);
    if (!resultado.success) {
        const onde = resultado.error.issues[0]?.path.join('.') ?? '?';
        throw new ErroDeMapeamento(`Linha de ${tabela} (id ${String(row['id'])}) inválida em ${onde}.`);
    }
    return resultado.data;
}
//# sourceMappingURL=mapeamento.js.map